<template>
<div class="chapter">
<div class="inner_page">
<p class="h2"><b>Contents</b></p>
<p class="toca"><a href="#/xhtml/9780292756441_08_pref">Preface</a></p>
<p class="toc"><a href="#/xhtml/9780292756441_10_ch1">1. Introduction</a></p>
<p class="toc"><span href="#/xhtml/9780292756441_11_ch2" title="Link target outside of Sample">2. The Sleepy Lagoon Case</span></p>
<p class="toc"><span href="#/xhtml/9780292756441_12_ch3" title="Link target outside of Sample">3. The “Zoot Suit Yokum” Conspiracy</span></p>
<p class="toc"><span href="#/xhtml/9780292756441_13_ch4" title="Link target outside of Sample">4. Servicemen and Zoot-Suiters</span></p>
<p class="toc"><span href="#/xhtml/9780292756441_14_ch5" title="Link target outside of Sample">5. The Zoot-Suit Riots</span></p>
<p class="toc"><span href="#/xhtml/9780292756441_15_ch6" title="Link target outside of Sample">6. The Symbols, Imagery, and Rhetoric of the Riots</span></p>
<p class="toc"><span href="#/xhtml/9780292756441_16_ch7" title="Link target outside of Sample">7. “The Hard to Get At”</span></p>
<p class="toc"><span href="#/xhtml/9780292756441_17_ch8" title="Link target outside of Sample">8. Between Annihilation and Redemption</span></p>
<p class="toca"><span href="#/xhtml/9780292756441_18_appa" title="Link target outside of Sample">Appendices</span></p>
<p class="toca"><span href="#/xhtml/9780292756441_24_note" title="Link target outside of Sample">Notes</span></p>
<p class="toca"><span href="#/xhtml/9780292756441_25_bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toca"><span href="#/xhtml/9780292756441_26_index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292756441_07_toc.vue?416e0847